/* eslint-disable eqeqeq */
/* eslint-disable radix */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable class-methods-use-this */
import classnames from "classnames";
import Element from "component/design-system/react-scroll/components/Element";
import Link from "next/link";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { PureComponent } from "react";
import { renderHTML } from "../../util/DomHelper";
import { isNumberNaN } from "../../util/helper/isNumberNaN";
import { scrollTo } from "../../util/scroll-helper";
import VizSensor from "../design-system/VizSensor";
import LandingPageBanner from "./LandingPageBanner";
import styles from "./landingPage.module.scss";

const propTypes = {
  data: PropTypes.object.isRequired,
};

const defaultProps = {
  data: {
    headers: {},
    d: [],
  },
};

class LandingPageAllParts extends PureComponent {
  onClickLetter(letter: any) {
    const element = `anchor_brand_${letter}`;

    scrollTo(element, {
      duration: 500,
      delay: 100,
      smooth: true,
      offset: -110,
    });
  }

  handleClickCategory(category: any) {
    this.props.router.push(category.url);
  }

  render() {
    const { data } = this.props;
    const parts = data.parts.sort((a: any, b: any) => a.name.localeCompare(b.name));
    const alphabet = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    let lastLetter: any;

    return (
      <div className={`container ${styles.landing_all_parts}`}>

        <h1><strong>{data.headers.h1}</strong></h1>

        <div>

          <LandingPageBanner
            bannerImages={{
              desktopImage: `${process.env.NEXT_PUBLIC_ROOT_URL}/images/landing-pages/${data.imageUrl}`,
              mobileImage: `${process.env.NEXT_PUBLIC_ROOT_URL}/images/landing-pages/${data.imageUrl}`,
            }}
            className="img-responsive width-100pct"
            alt={data.headers.h1}
          />
        </div>

        <div className={`${styles.section} ${styles.section_odd}`}>

          <div className="m-t-20 m-b-20" dangerouslySetInnerHTML={renderHTML(data.d[0])} />

          <h2>{data.headers.h2S1}</h2>

          <div className={styles.letters}>
            {alphabet.map((letter, index) => (
              <div
                key={index}
                className={classnames({ [styles.disabled]: (parts.findIndex((p: any) => p.name.charAt(0).toUpperCase() === letter || (letter === "#" && !isNumberNaN(parseInt(p.name.charAt(0))))) === -1) })}
                onClick={this.onClickLetter.bind(this, letter)}
              >
                {letter.toUpperCase()}
              </div>
            ))}
          </div>

          <hr className="m-t-20" style={{ borderColor: "#d7d7d7" }} />

          <div className={`row ${styles.row}`}>
            {parts && parts.map((p: any, index: number) => {
              let createElement = false;
              let firstLetter = p.name.charAt(0).toUpperCase();
              firstLetter = (!isNumberNaN(parseInt(firstLetter))) ? "#" : firstLetter;
              if (firstLetter != lastLetter) {
                lastLetter = firstLetter;
                createElement = true;
              }
              return (
                <div className="col-sm-6 col-md-4 col-lg-3" key={index}>

                  {createElement && <Element name={`anchor_brand_${lastLetter}`} />}

                  <div className={`panel panel-default pointer ${styles.panel}`}>

                    <Link href={p.url}>

                      <div className={`panel-heading ${styles.panel_heading}`}>{p.name}</div>
                      <div className={`panel-body ${styles.panel_body}`}>

                        <VizSensor forceSSR minHeight={130}>

                          <img
                            alt={p.name}
                            src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/${p.thumbnaillUrl}`}
                            style={{ minHeight: 130, minWidth: 217 }}
                          />
                        </VizSensor>
                      </div>

                    </Link>
                  </div>
                </div>
              );
            })}
          </div>

          <div dangerouslySetInnerHTML={renderHTML(data.d[1])} />
        </div>
      </div>
    );
  }
}

LandingPageAllParts.propTypes = propTypes;

LandingPageAllParts.defaultProps = defaultProps;

const LandingPageAllPartsWithRouter = (props: any) => {
  const router = useRouter();
  return (
    <LandingPageAllParts
      {...props}
      router={router}
    />
  );
};

export default LandingPageAllPartsWithRouter;
